import React, { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Pagination from "../Reusablecomponents/Pagination";
import "../css/others/Table.css";
import { apiCall } from "../main/ApiCall";
import { MeetingDetails } from "../interFaces/interfaces";
const FunctionMeetingTrackerDetails: React.FC = () => {
    const { campaignId } = useParams<{ campaignId: string }>();
    const navigate = useNavigate();
    const clientId = localStorage.getItem("clientId");
    const [data, setData] = useState<MeetingDetails[]>([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const fetchMeetingDetails = useCallback(async () => {
        if (!campaignId) return;
        setLoading(true);
        try {
            const response = await apiCall("get", `/api/function-meeting-tracking/${clientId}/${campaignId}?page=${currentPage - 1}&size=${itemsPerPage}`);
            if (response?.content) {
                setData(response.content);
                setTotalPages(response.totalPages || 0);
                setTotalElements(response.totalElements || 0);
            } else {
                setData([]);
                setTotalPages(0);
                setTotalElements(0);
            }
        } catch (error) {
            console.error("Failed to fetch meeting details", error);
        } finally {
            setLoading(false);
        }
    }, [clientId, campaignId, currentPage, itemsPerPage]);
    useEffect(() => {
        fetchMeetingDetails();
    }, [fetchMeetingDetails]);
    const handleProjectClick = (functionId: string) => {
        navigate(`/functionmeetingtrackerdetailsinfo/${campaignId}/${functionId}`);
    };
    return (
        <div className="table-details">
            <div className="table-title">
                <h2>Function Meeting Tracker Details</h2>
            </div>
            <div className="table-container">
                <div className="table-inner-container">
                    <table className="main-table">
                        <thead>
                            <tr>
                                <th>Function ID</th>
                                <th>Function Name</th>
                                <th>Meeting Status</th>
                                <th>Scheduled Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={4} className="no-data">Loading..</td>
                                </tr>
                            ) : data.length > 0 ? (
                                data.map(item => (
                                    <tr key={item.functionId}>
                                        <td className="clickable" onClick={() => handleProjectClick(item.functionId)}>{item.functionId}</td>
                                        <td>{item.functionName}</td>
                                        <td>{item.meetingStatus}</td>
                                        <td>{new Date(item.scheduledTime).toLocaleString()}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4} className="no-data">No meeting details found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
        </div>
    );
}
export default FunctionMeetingTrackerDetails;